import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GenericModal from '../../../components/modal/GenericModal';
import SpinnerLoading from '../../../components/pageComponents/SpinnerLoading';
import { useGetRequest } from '../../../hooks/useGetRequest/useGetRequest';
import { responseCode200, mostrarMensajeDeErrorConToast } from '../../../consumers/httpRequiestsUtils';
import { getDetalleSolicitudPrestamoAPI } from '../../../consumers/backendApisUrls';
import { formatearMesPreview } from '../../../helper/utils';
import InputBool from '../../../components/modalComponents/InputBool';

const VerDetallePrestamoModal = ({ showModal, idPrestamo, 
    fromAdminPage = false, 
    puedeAprobarRechazar = false, 
    puedeObservar = false, 
    esGestorPrestamos = false, 
    onAbrirAccion, 
    fechaIngreso = "",
    rolLiderEquipo = false,
    rolDirector = false
     }) => {
    const [isLoading, setIsLoading] = useState(true);
    const [detalle, setDetalle] = useState(null);
    const [executeGetRequest] = useGetRequest();

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        setIsLoading(true);
        try {
            const response = await executeGetRequest(getDetalleSolicitudPrestamoAPI(idPrestamo));
            if (responseCode200(response)) {
                setDetalle(response.data);
            } else {
                mostrarMensajeDeErrorConToast(response);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    if (isLoading) return <SpinnerLoading />;
    //const puedeAccionar = esGestorPrestamos ? detalle?.IdEstadoProceso !== 15 : true;

    const esAprobadorNivel1 = !esGestorPrestamos && (rolLiderEquipo || rolDirector);
    const nivel        = detalle?.IdNivelAprobaci;
    const estado       = detalle?.IdEstadoProceso;
    const esPendiente  = estado === 44;
    const esObservada  = estado === 13;

    // Aprobar: solo si estado=44 (pendiente)
    //   - esAprobadorNivel1 → solo si nivel=1
    //   - esGestorPrestamos → nivel 1 o 2, pero NO si nivel=2 y estado=14 (ya aprobado final)
    const mostrarAprobar =
        fromAdminPage &&
        puedeAprobarRechazar &&
        esPendiente &&
        (
            (esAprobadorNivel1 && nivel === 1) ||
            (esGestorPrestamos && !(nivel === 2 && estado === 14))
        );

    // Rechazar:
    //   - esAprobadorNivel1 → solo si está pendiente y en nivel 1 (misma regla que Aprobar)
    //   - esGestorPrestamos → puede rechazar si está Pendiente (44) u Observada (13)
    //   - esGestorPrestamos → también puede rechazar aunque ya esté Aprobado en Nivel 2 (14)
    const mostrarRechazar =
        fromAdminPage &&
        puedeAprobarRechazar &&
        (
            (esPendiente && esAprobadorNivel1 && nivel === 1) ||
            (esGestorPrestamos && (esPendiente || esObservada)) ||
            (esGestorPrestamos && nivel === 2 && estado === 14)
        );

    // Observar: solo Gestor de Préstamos, nivel=2, puedeObservar=true
    //   LiderEquipo y Director NO pueden observar (esAprobadorNivel1 excluye)
    const mostrarObservar =
        fromAdminPage &&
        puedeObservar &&
        esGestorPrestamos &&
        !esAprobadorNivel1 &&
        nivel === 2;

    const hayBotones = mostrarAprobar || mostrarRechazar || mostrarObservar;

    return (
        <GenericModal titulo="Detalle de Solicitud" showModal={showModal} width='750px'>
            <div className="modal-body">
                {detalle ? (
                    <>
                    <form>
                        <div className="form-row">
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Colaborador</label>
                                <input type="text" className="form-control" value={detalle.Colaborador ?? ""} disabled />
                            </div>
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Correo</label>
                                <input type="text" className="form-control" value={detalle.CorreoCorporativo ?? ""} disabled />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Sede</label>
                                <input type="text" className="form-control" value={detalle.Sede ?? ""} disabled />
                            </div>
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Cargo</label>
                                <input type="text" className="form-control" value={detalle.Cargo ?? ""} disabled />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Fecha Ingreso Colaborador</label>
                                <input type="text" className="form-control" value={fechaIngreso ?? ""} disabled />
                            </div>
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Fecha Registro</label>
                                <input type="text" className="form-control" value={detalle.FechaRegistro ?? ""} disabled />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Estado</label>
                                <input type="text" className="form-control" value={detalle.EstadoProceso ?? ""} disabled />
                            </div>
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Tipo Solicitud</label>
                                <input type="text" className="form-control" value={detalle.TipoSolicitud ?? ""} disabled />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Nivel Aprobación</label>
                                <input type="text" className="form-control" value={detalle.NivelAprobacion ?? ""} disabled />
                            </div>
                            <div className="form-group col-sm-6">
                                <label className="modal-label mb-0">Monto (S/.)</label>
                                <input type="text" className="form-control"
                                    value={detalle.Monto ? `S/. ${parseFloat(detalle.Monto).toFixed(2)}` : "-"} disabled />
                            </div>
                        </div>
                        <div className="form-row">
                            {detalle.NroCuotas > 0 && (
                                <div className="form-group col-sm-6">
                                    <label className="modal-label mb-0">Nro. Cuotas</label>
                                    <input type="text" className="form-control" value={detalle.NroCuotas ?? ""} disabled />
                                </div>
                            )}
                            {detalle.MesDsctoGratificacion && (
                                <div className="form-group col-sm-6">
                                    <label className="modal-label mb-0">Mes Descuento Gratificación</label>
                                    <input type="text" className="form-control" value={detalle.MesDsctoGratificacion} disabled />
                                </div>
                            )}
                            {detalle.MesInicioDescuento && detalle.MesInicioDescuento != 0 && (
                                <div className="form-group col-sm-6">
                                    <label className="modal-label mb-0">Mes Inicio Descuento</label>
                                    <input type="text" className="form-control" value={formatearMesPreview(detalle.MesInicioDescuento)} disabled />
                                </div>
                            )}
                            {detalle.MesFinDescuento && detalle.MesFinDescuento !=0 && (
                                <div className="form-group col-sm-6">
                                    <label className="modal-label mb-0">Mes Fin Descuento</label>
                                    <input type="text" className="form-control" value={formatearMesPreview(detalle.MesFinDescuento)} disabled />
                                </div>
                            )}
                        </div>
                        <div className="form-row">
                            {detalle.MotivoPrestamo && (
                                <div className="form-group col-sm-12">
                                    <label className="modal-label mb-0">Motivo Solicitud</label>
                                    <textarea className="form-control" rows={2} value={detalle.MotivoPrestamo} disabled />
                                </div>
                            )}
                            {(detalle.MotivoRechazo || detalle.MotivoObservacion) && (
                                <div className="form-group col-sm-12">
                                    <label className="modal-label mb-0">Observación / Rechazo</label>
                                    <textarea className="form-control" rows={3} value={detalle.MotivoRechazo || detalle.MotivoObservacion} disabled />
                                </div>
                            )}
                        </div>
                        <div className="form-row">
                            <div className="form-group col-sm-12">
                                <label className="modal-label mb-0">Documento de Autorizaci&oacute;n</label>
                                <div style={{ paddingTop: "6px" }}>
                                    {detalle.ArchivoUrl ? (
                                        <a href={detalle.ArchivoUrl}
                                           target="_blank"
                                           rel="noopener noreferrer"
                                           className="blue-standard-color">
                                            <FontAwesomeIcon icon="file" className="mr-1" />
                                            {detalle.ArchivoNombre || "Ver archivo"}
                                        </a>
                                    ) : (
                                        <span className="font-size-search-label-text">Sin archivo adjunto</span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-sm-12">
                                <label className="modal-label mb-0">Documento Sustento</label>
                                <div style={{ paddingTop: "6px" }}>
                                    {detalle.ArchivoSustentoUrl ? (
                                        <a href={detalle.ArchivoSustentoUrl}
                                           target="_blank"
                                           rel="noopener noreferrer"
                                           className="blue-standard-color">
                                            <FontAwesomeIcon icon="file" className="mr-1" />
                                            {detalle.ArchivoSustentoNombre || "Ver archivo"}
                                        </a>
                                    ) : (
                                        <span className="font-size-search-label-text">Sin archivo sustento</span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            {fromAdminPage && (
                            <>
                            <div className="form-group col-sm-6">
                                <InputBool
                                    label="Excepción"
                                    name="TieneExcepcion"
                                    value={detalle.TieneExcepcion ?? false}
                                    isDisabled={true}
                                    sectionName="VerDetallePrestamoModal"
                                />
                            </div>
                            {detalle.TieneExcepcion && (
                            <div className="form-group col-sm-12">
                                <label className="modal-label mb-0">Detalle de Excepción</label>
                                <textarea className="form-control" rows={2}
                                    value={detalle.MotivoExcepcion ?? ""} disabled />
                            </div>
                            )}
                            </>
                            )}
                            {fromAdminPage && detalle.NombreApruebaNivel2 && (
                            <div className="form-row col-sm-12">
                                <div className="form-group col-sm-8">
                                    <label className="modal-label mb-0">Aprobador</label>
                                    <input type="text" className="form-control"
                                        value={detalle.NombreApruebaNivel2} disabled />
                                </div>
                                <div className="form-group col-sm-4">
                                    <label className="modal-label mb-0">Fecha Aprobación N2</label>
                                    <input type="text" className="form-control"
                                        value={detalle.FechaApruebaNivel2} disabled />
                                </div>
                            </div>
                            )}
                            {fromAdminPage && detalle.ComentarioApruebaNivel2 && (
                            <div className="form-row col-sm-12">
                                <div className="form-group col-sm-12">
                                    <label className="modal-label mb-0">Comentario de Aprobación N2</label>
                                    <textarea className="form-control" 
                                        value={detalle.ComentarioApruebaNivel2} disabled />
                                </div>
                            </div>
                            )}
                            {fromAdminPage && detalle.ComunicoAJefe === false && (
                        <div className="form-row">
                            <div className="form-group col-sm-12">
                                <div className="alert alert-warning mb-0" role="alert">
                                    <FontAwesomeIcon icon="exclamation-triangle" className="mr-2" />
                                    El colaborador registra que <strong><spam style={{color: 'red'}}>NO</spam></strong> hubo coordinaci&oacute;n previa.
                                    Si est&aacute;s de acuerdo o conversaron despu&eacute;s de esta solicitud,
                                    puedes aprobarla con normalidad. No se requiere cambiar este campo.
                                </div>
                            </div>
                        </div>
                        )}
                        {fromAdminPage && detalle.ComunicoAJefe === true && (
                        <div className="form-row">
                            <div className="form-group col-sm-12">
                                <div className="alert alert-success mb-0" role="alert">
                                    <FontAwesomeIcon icon="check-circle" className="mr-2" />
                                    El colaborador indica que <strong>Sí</strong> coordin&oacute; esta solicitud con su Líder.
                                </div>
                            </div>
                        </div>
                        )}
                        </div>
                    </form>
                    {hayBotones && (
                        <div className="modal-footer justify-content-end">
                            <div className="d-flex justify-content-center align-items-center" style={{ gap: "10px" }}>

                                {mostrarAprobar && (                            
                                    <button type="button" className="btn generic-button-buscador generic-button-hover-verde"
                                        onClick={() => onAbrirAccion(idPrestamo, 'APROBAR', nivel)}>
                                        Aprobar
                                    </button>
                                )}

                                {mostrarRechazar && (
                                    <button type="button" className="btn generic-button-buscador generic-button-hover-rojo"
                                        onClick={() => onAbrirAccion(idPrestamo, 'RECHAZAR', nivel)}>
                                        Rechazar
                                    </button>    
                                )}                                                                
                            
                                {mostrarObservar && (
                                    <button type="button" className="btn generic-button-buscador generic-button-hover-amarillo"
                                        onClick={() => onAbrirAccion(idPrestamo, 'OBSERVAR', nivel)}>
                                        Observar
                                    </button>
                                )}
                                
                            </div>
                        </div>
                    )}
                    </>
                ) : (
                    <p className="text-center font-size-search-label-text">
                        No se encontró información de la solicitud.
                    </p>
                )}
            </div>
        </GenericModal>
    );
};

export default VerDetallePrestamoModal;
